import { SessionService } from '@services/session.service';
import { MenuService } from '@services/menu.service';
import { AlertController, LoadingController, MenuController, NavController, ToastController } from '@ionic/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { EnumAppMenu } from '@models/AppMenus';
import { ActivatedRoute } from '@angular/router';
import { BasePage } from '@pages/BasePage';

export enum EnumPageStates {
    SESSIONENDED = '419',
    NOTFOUND = "404",
    DEFAULT = ''
}

@Component({
    selector: 'app-error',
    templateUrl: './error.page.html',
    styleUrls: ['./error.page.scss'],
})
export class ErrorPage extends BasePage implements OnInit, OnDestroy {

    public State: string = EnumPageStates.DEFAULT;

    public EnumPageStates = EnumPageStates;


    private timeout: any;
    private menus;

    constructor(protected ActivatedRoute: ActivatedRoute,
        protected LoadingController: LoadingController,
        protected ToastController: ToastController,
        protected AlertController: AlertController,
        private MenuController: MenuController,
        private NavController: NavController,
        private MenuService: MenuService,
        private SessionService: SessionService) {

        super(ActivatedRoute, LoadingController, ToastController, AlertController);
    }

    async ngOnInit() {

        this.MenuController.close();
        this.MenuController.enable(false);

        this.State = String(this.PageQueryParams?.id) || '';

        this.menus = await this.MenuService.GetMenus();

        console.log(this.SessionService.HasSession());


        this.timeout = setTimeout(() => {

            clearTimeout(this.timeout);

            if (this.menus?.length == 0 || !this.SessionService.HasSession())
                this.SessionService.SaveSession(null);

        }, 300000);
    }

    async ngOnDestroy() {

        if (this.timeout)
            clearTimeout(this.timeout);

        if (this.menus?.length > 0)
            this.MenuController.enable(true);

    }

    GoBack() {

        if (this.menus?.length == 0 || !this.SessionService.HasSession())
            this.SessionService.SaveSession(null);

        this.NavController.navigateRoot([EnumAppMenu.Initialize])
    }

}
